// Aurum Brothers — custom JavaScript

// === Featured collections — sliding tab indicator (data-active) ===
(function () {
  function initFeaturedCollectionsNav() {
    document.querySelectorAll('.featured-collections-navigation').forEach(function (nav) {
      var buttons = Array.from(nav.querySelectorAll('button'));

      function setActive(index) {
        nav.setAttribute('data-active', index);
      }

      // Set initial state from aria-current
      var initial = buttons.findIndex(function (b) {
        return b.getAttribute('aria-current') === 'true';
      });
      setActive(initial >= 0 ? initial : 0);

      // Update on click
      buttons.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          setActive(index);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionsNav);
  } else {
    initFeaturedCollectionsNav();
  }
})();

// === Size limits tooltip — mobile click toggle (KAN-82) ===
var sizeLimitsReady = false;

function initSizeLimits() {
  document.querySelectorAll('.size-limits').forEach(function (widget) {
    var trigger = widget.querySelector('.size-limits__trigger');
    var closeBtn = widget.querySelector('.size-limits__close');

    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });

  if (!sizeLimitsReady) {
    sizeLimitsReady = true;
    document.addEventListener('click', function () {
      document.querySelectorAll('.size-limits__trigger[aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeLimits);
} else {
  initSizeLimits();
}

// === Reusable info point tooltip — mobile click toggle (KAN-126) ===
// Mirrors the size-limits behaviour for any .info-point widget (e.g. Pre-order).
//
// KAN-142 rewrote this as a single delegated listener, which fixed two things the
// per-widget version got wrong:
//
// 1. Tooltips stacked. Each trigger called stopPropagation, so the document-level
//    "close everything" never ran when a trigger was clicked and an already-open
//    bubble stayed open behind the new one.
// 2. In the collection quiz they stopped working after the first answer. Listeners
//    were bound once on DOMContentLoaded, but answering re-renders the whole
//    section through the facets AJAX engine, so every rebuilt icon was inert.
//
// Delegation covers markup that does not exist yet, so there is nothing to
// re-initialise and no window in which a fresh icon is dead.
// KAN-142: the quiz bubble is taken out of the flow (its row is a scroll
// container that would clip it) and sits above the icon that opened it, with a
// tail pointing back down at that icon. CSS cannot know where the icon is, so
// its position is measured here and handed over as custom properties. Read after
// the bubble is visible — a display:none element measures as zero.
function positionInfoPointBubble(trigger) {
  var widget = trigger.closest('.info-point');
  var bubble = widget && widget.querySelector('.info-point__bubble');
  if (!bubble) return;

  var t = trigger.getBoundingClientRect();
  var anchorX = t.left + t.width / 2;

  bubble.style.setProperty('--info-point-anchor-x', anchorX + 'px');
  bubble.style.setProperty('--info-point-anchor-y', t.top + 'px');
  bubble.style.setProperty('--info-point-anchor-height', t.height + 'px');

  // Above by default, below when there is not enough headroom. Without this the
  // bubble runs off the top of the screen for a question sitting high on the
  // page, which is easy to hit on a phone where the viewport is short.
  var b = bubble.getBoundingClientRect();
  var roomAbove = t.top - b.height - 12;
  bubble.setAttribute('data-placement', roomAbove < 8 ? 'below' : 'above');

  // The tail is placed relative to the bubble, so it needs the anchor expressed
  // as an offset from the bubble's own left edge rather than the viewport's.
  bubble.style.setProperty('--info-point-tail-x', anchorX - b.left + 'px');
}

document.addEventListener('click', function (e) {
  var closeBtn = e.target.closest('.info-point__close');

  if (closeBtn) {
    var owner = closeBtn.closest('.info-point');
    var ownTrigger = owner && owner.querySelector('.info-point__trigger');
    if (ownTrigger) ownTrigger.setAttribute('aria-expanded', 'false');
    return;
  }

  var trigger = e.target.closest('.info-point__trigger');

  // Close every other bubble first, so opening one always shuts the last. Also
  // handles a click anywhere else on the page, including the dimmed backdrop
  // behind an open quiz tooltip.
  document.querySelectorAll('.info-point__trigger[aria-expanded="true"]').forEach(function (t) {
    if (t !== trigger) t.setAttribute('aria-expanded', 'false');
  });

  if (trigger) {
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    if (!isOpen) positionInfoPointBubble(trigger);
  }
});

// === Homepage Hero Parallax (GSAP ScrollTrigger) ===
// Targets Prestige theme's slideshow section (.shopify-section--slideshow)
function initHeroParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  // Prestige wraps the slideshow section in .shopify-section--slideshow
  var heroSection = document.querySelector('.shopify-section--slideshow');
  if (!heroSection) return;

  // First active slide — Prestige adds .is-selected on initialisation
  var firstSlide =
    heroSection.querySelector('.slideshow__slide.is-selected') || heroSection.querySelector('.slideshow__slide');
  if (!firstSlide) return;

  // Prestige slideshow renders the background image as a bare <picture> inside .content-over-media
  var heroImage = firstSlide.querySelector('picture');
  // Text overlay lives in .slideshow__slide-content
  var heroContent = firstSlide.querySelector('.slideshow__slide-content');

  // Pre-scale the picture so the edges never show while it moves
  if (heroImage) {
    gsap.set(heroImage, { scale: 1.15, transformOrigin: '50% 50%' });
    // Image drifts down (slower) → depth effect
    gsap.to(heroImage, {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5,
      },
    });
  }

  // Text drifts upward faster → reinforces the parallax separation
  if (heroContent) {
    gsap.to(heroContent, {
      yPercent: -15,
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5,
      },
    });
  }
}

// GSAP is NOT loaded upfront (it used to cost ~110 KB / >1s of mobile
// main-thread on every homepage visit). We inject the self-hosted files only
// when the slideshow hero actually exists on the page — today it's disabled in
// templates/index.json (the Shoplift hero replaced it), so nothing loads; if
// the slideshow is ever re-enabled, the parallax comes back automatically.
function loadHeroParallax() {
  var assets = window.skbGsapAssets;
  if (!assets || !document.querySelector('.shopify-section--slideshow')) return;

  function inject(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  // ScrollTrigger depends on the gsap core, so load sequentially.
  inject(assets.gsap)
    .then(function () {
      return inject(assets.scrollTrigger);
    })
    .then(initHeroParallax)
    .catch(function () {
      /* parallax is a progressive enhancement — fail silently */
    });
}

document.addEventListener('DOMContentLoaded', function () {
  loadHeroParallax();
});

// === Variant Thumb Switcher — product card swatch click ===

function variantThumb_readData(thumb, handle) {
  const thumbsWrapper = thumb.closest('.variant-thumbs');
  if (!thumbsWrapper) return null;

  const selectorHandle = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"');
  const template = thumbsWrapper.querySelector('template[data-product-handle="' + selectorHandle + '"]');
  if (!template) return null;

  const script = template.content
    ? template.content.querySelector('script[type="application/json"]')
    : template.querySelector('script[type="application/json"]');
  if (!script) return null;

  try {
    return JSON.parse(script.textContent.trim());
  } catch (err) {
    console.error('Invalid template JSON', err);
    return null;
  }
}

function variantThumb_updateMedia(card, data) {
  const img = card.querySelector('.product-card__image--primary') || card.querySelector('.product-card__media img');
  if (!img || !data.image) return;
  const base = data.image.replace(/&width=\d+/, '');
  img.src = data.image;
  img.srcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800]
    .map(function (w) {
      return base + '&width=' + w + ' ' + w + 'w';
    })
    .join(', ');
}

function variantThumb_updateLinks(card, data) {
  const mediaLink = card.querySelector('.product-card__media');
  if (mediaLink) mediaLink.href = data.url;

  const titleEl = card.querySelector('.product-title');
  if (titleEl) {
    titleEl.textContent = data.title;
    titleEl.href = data.url;
  }
}

function variantThumb_updatePrice(card, data) {
  const oldPrice = card.querySelector('.price-list');
  if (!oldPrice || !data.price_html) return;
  const temp = document.createElement('div');
  temp.innerHTML = data.price_html;
  oldPrice.replaceWith(temp.firstElementChild);
}

function variantThumb_updateVariantId(card, handle, data) {
  const variantInput = card.querySelector('input[name="id"]');
  if (variantInput && data.variant_id) variantInput.value = data.variant_id;

  const quickBuyModal = card.querySelector('quick-buy-modal');
  if (quickBuyModal) quickBuyModal.setAttribute('handle', handle);
}

function variantThumb_updateActiveState(card, activeThumb) {
  card.querySelectorAll('.variant-thumb').forEach(function (el) {
    el.classList.remove('selected');
    const elImg = el.querySelector('img');
    if (elImg) elImg.style.borderBottom = 'none';
  });
  activeThumb.classList.add('selected');
  const thumbImg = activeThumb.querySelector('img');
  if (thumbImg) thumbImg.style.borderBottom = '3px solid white';
}

function variantThumb_updateRating(card, data) {
  card.querySelectorAll('.ab-rating[data-product-id]').forEach(function (el) {
    el.style.display = String(el.dataset.productId) === String(data.product_id) ? '' : 'none';
  });
}

function variantThumb_updateBadges(card, data) {
  const figure = card.querySelector('.product-card__figure');
  let badgeList = card.querySelector('badge-list');
  if (!badgeList && figure) {
    badgeList = document.createElement('badge-list');
    badgeList.className = 'badge-list badge-list--vertical';
    figure.prepend(badgeList);
  }
  if (!badgeList) return;

  badgeList.innerHTML = '';
  if (data.badge) {
    const badges = Array.isArray(data.badge) ? data.badge : [data.badge];
    badges.forEach(function (text) {
      if (!text || !text.trim()) return;
      const span = document.createElement('span');
      span.className = 'badge badge--custom';
      span.textContent = text;
      badgeList.appendChild(span);
    });
  }
  const soldOutLabel = window.themeVariables?.strings?.soldOutBadge;
  if (data.available === false && soldOutLabel) {
    // Skip the badge entirely when the string is unavailable — an empty
    // <sold-out-badge> would still paint as a coloured pill.
    const soldOut = document.createElement('sold-out-badge');
    soldOut.className = 'badge badge--sold-out';
    soldOut.textContent = soldOutLabel;
    badgeList.appendChild(soldOut);
  }
  badgeList.hidden = badgeList.children.length === 0;
}

function variantThumb_updateQuickBuy(card, data) {
  const btn = card.querySelector('.product-card__quick-add-button');
  if (btn) btn.style.display = data.available === false ? 'none' : '';
}

document.addEventListener('click', function (e) {
  const thumb = e.target.closest('.variant-thumb');
  if (!thumb) return;

  const card = thumb.closest('.product-card');
  if (!card) return;

  const handle = thumb.dataset.variantHandle;
  if (!handle) return;

  const data = variantThumb_readData(thumb, handle);
  if (!data) return;

  variantThumb_updateMedia(card, data);
  variantThumb_updateLinks(card, data);
  variantThumb_updatePrice(card, data);
  variantThumb_updateVariantId(card, handle, data);
  variantThumb_updateActiveState(card, thumb);
  variantThumb_updateRating(card, data);
  variantThumb_updateBadges(card, data);
  variantThumb_updateQuickBuy(card, data);
});

// === Sticky ATC (scroll-back mode) — button handler ===
function skbSmoothScroll(targetY, duration) {
  var startY = window.pageYOffset;
  var diff = targetY - startY;
  var startTime = null;
  function step(ts) {
    if (!startTime) startTime = ts;
    var p = Math.min((ts - startTime) / duration, 1);
    var ease = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
    window.scrollTo(0, startY + diff * ease);
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-sticky-atc-trigger]');
  if (!btn) return;
  var formId = btn.dataset.stickyAtcTrigger;
  var f = document.getElementById('wrist-size');
  if (f && f.value.trim() === '') {
    // Pin the label+field to a fixed offset below the top of the viewport
    // instead of centering in whatever space is left once the keyboard
    // opens — the keyboard only eats space from the bottom, so a top-anchored
    // target is independent of keyboard height and identical on every
    // phone/browser, unlike centering (which needs to know exactly how tall
    // the keyboard + any autofill bar is).
    var wrap = f.closest('.line-item-property') || f;
    var stickyAreaHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
    // Margin above the field scales with screen height instead of a flat
    // pixel value — a fixed px clears the browser's address-bar chrome fine
    // on a tall phone but eats proportionally more of a small phone's
    // screen, so it still doesn't leave enough room there. 14% of the
    // viewport height, clamped, tracks screen size directly.
    var topMargin = Math.max(60, Math.min(window.innerHeight * 0.14, 160));
    var targetY = window.pageYOffset + wrap.getBoundingClientRect().top - stickyAreaHeight - topMargin;
    skbSmoothScroll(targetY, 600);
    f.focus({ preventScroll: true });
  } else {
    document.querySelector('#' + formId + ' [type=submit]')?.click();
  }
});

// === Sticky ATC (scroll-back mode) — reliable scroll-based visibility ===
// The native IntersectionObserver in theme.js has edge cases with mobile virtual
// keyboards and smooth scrolling. We override visibility with a direct scroll check
// so the bar ALWAYS appears when the user is below the ATC form.
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('product-sticky-bar.product-sticky-bar--scroll-only');
  if (!bar) return;

  var formId = bar.getAttribute('form');
  var form = document.getElementById(formId) || document.forms[formId];
  if (!form) return;

  var footer = document.querySelector('.shopify-section--footer');

  function updateVisibility() {
    var formBottom = form.getBoundingClientRect().bottom;
    var belowForm = formBottom < 0;
    var beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;

    var shouldShow = belowForm && beforeFooter;
    bar.classList.toggle('is-visible', shouldShow);
    if (shouldShow) bar.removeAttribute('hidden');
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  // Also catch viewport changes from mobile keyboard
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateVisibility);
  }
  updateVisibility();
});

// Scroll so an element's top sits just under the sticky header.
function skbScrollToElement(target, duration, gap) {
  var sticky = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
  var y = window.pageYOffset + target.getBoundingClientRect().top - sticky - (gap || 0);
  skbSmoothScroll(Math.max(0, y), duration);
}

// === Judge.me rating: smooth scroll to the reviews (was KAN-192 for Klaviyo) ===
// The rating on the product page (snippets/ab-rating.liquid, on_page) links to
// #judgeme_product_reviews. Scroll there ourselves so the sticky header doesn't cover the
// heading. Arriving from a card link (/products/x#judgeme_product_reviews) does the same once
// Judge.me has filled its widget, since the anchor isn't in the HTML on first paint.
(function () {
  var HASH = '#judgeme_product_reviews';
  // Enough of a gap under the sticky header that the heading is not flush against it.
  var BREATHING_ROOM = 16;

  function findTarget() {
    return document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
  }

  function scrollToReviews(duration) {
    var target = findTarget();
    if (!target) return false;
    skbScrollToElement(target, duration, BREATHING_ROOM);
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a.ab-rating--on-page');
    if (!link || !findTarget()) return;
    event.preventDefault();
    scrollToReviews(600);
  });

  // Landing with the hash: skip product pages with the discovery layout, which handle it themselves.
  if (window.location.hash === HASH && !document.querySelector('ab-pdp-discovery')) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var target = findTarget();
      var filled = target && target.querySelector('[class*="jm-review"], .jdgm-rev-widg');
      if (filled || tries > 40) {
        clearInterval(timer);
        if (target) scrollToReviews(0);
      }
    }, 250);
  }
})();

// === Hero rating line → reviews further down the page (Image hero 1.1, "Reviews on this page") ===
// Finds the first reviews section below: a Judge.me widget/carousel app block first, the
// Featured reviews section as a fallback. Without one the line is left unclickable.
(function () {
  var TARGETS = [
    '[id*="judge_me_reviews"]',
    '.jdgm-carousel-wrapper',
    '.jdgm-widget:not(.jdgm-preview-badge):not(.jdgm-prev-badge)',
    '.shopify-section--featured-reviews'
  ];

  function findTarget(link) {
    for (var i = 0; i < TARGETS.length; i++) {
      var nodes = document.querySelectorAll(TARGETS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        // Must come after the link in the page and not be inside the header area
        if (link.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING && !node.closest('.sl-block')) {
          return node.closest('.shopify-section') || node;
        }
      }
    }
    return null;
  }

  function refresh() {
    document.querySelectorAll('[data-ab-reviews-jump]').forEach(function (link) {
      link.classList.toggle('ab-hero-reviews-link--inactive', !findTarget(link));
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('[data-ab-reviews-jump]');
    if (!link) return;
    event.preventDefault();
    var target = findTarget(link);
    if (target) skbScrollToElement(target, 700, 16);
  });

  refresh();
  // App blocks can render late; check again once everything has loaded.
  window.addEventListener('load', refresh);
})();

// === Cart add-to-cart failure tracking → GTM dataLayer → GA4 ===
// Prestige dispatches a bubbling `cart:error` event from the <product-form>'s
// inner <form> when an add-to-cart request fails (out of stock, quantity limit,
// etc.). We forward it to GTM's dataLayer as `cart_add_error`.
// The cart-page quantity updater also emits `cart:error` (with detail.message),
// so we only handle events that originate from an add-to-cart <form>.
(function () {
  document.addEventListener('cart:error', function (event) {
    var form = event.target;

    // Only track add-to-cart failures, not cart quantity-update errors.
    var isAddForm = form && form.tagName === 'FORM' && /\/cart\/add/.test(form.action || '');
    if (!isAddForm) return;

    var detail = event.detail || {};
    var variantField = form.elements ? form.elements['id'] : null;
    var productField = form.elements ? form.elements['product-id'] : null;
    var card = form.closest ? form.closest('product-card') : null;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cart_add_error',
      error_message: detail.error || detail.message || 'unknown',
      variant_id: variantField && variantField.value ? variantField.value : 'unknown',
      product_id: productField && productField.value ? productField.value : 'unknown',
      product_handle: card && card.getAttribute('handle') ? card.getAttribute('handle') : 'unknown',
      page_url: window.location.href,
      page_path: window.location.pathname,
    });
  });
})();

// === Featured reviews (KAN-88): store-wide latest Klaviyo reviews ===
// Hydrates the custom `featured-reviews` section. Fetches the latest published
// reviews store-wide from Klaviyo's onsite client API (no key needed; public
// company_id only) and renders a multi-column grid of cards, each linking to its
// connected product. Replaces the default testimonial carousel.
//
// IMPORTANT: hit fast.a.klaviyo.com directly — a.klaviyo.com 301-redirects and
// drops the Access-Control-Allow-Origin header, which CORS-blocks the request.
(function () {
  var ENDPOINT = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/all/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stars(rating) {
    var n = Math.max(0, Math.min(5, Math.round(rating || 0)));
    // role="img" + aria-label gives screen readers a single "n out of 5 stars"
    // label; the ★ glyphs are decorative and hidden so they aren't read out too.
    return (
      '<span class="ab-review__stars" role="img" aria-label="' +
      n +
      ' out of 5 stars">' +
      '<span class="ab-review__stars-on" aria-hidden="true">' +
      Array(n + 1).join('★') +
      '</span>' +
      '<span class="ab-review__stars-off" aria-hidden="true">' +
      Array(6 - n).join('★') +
      '</span>' +
      '</span>'
    );
  }

  // Reviews are publicly submittable, so treat product.image_url as untrusted:
  // only emit it if it's an absolute https URL.
  function safeImageUrl(url) {
    return typeof url === 'string' && /^https:\/\//i.test(url) ? url : '';
  }

  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try {
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function cardHtml(review, opts) {
    var product = review.product || {};
    var content = (review.content || '').trim();
    var parts = [];

    parts.push(stars(review.rating));
    if (review.title) parts.push('<h3 class="ab-review__title">' + esc(review.title) + '</h3>');
    if (content) parts.push('<p class="ab-review__body" title="' + esc(content) + '">' + esc(content) + '</p>');

    var meta = [];
    if (review.author) meta.push('<span class="ab-review__author">' + esc(review.author) + '</span>');
    if (review.verified) meta.push('<span class="ab-review__verified">Verified</span>');
    if (opts.showDate && review.created_at) {
      var dt = formatDate(review.created_at);
      if (dt) meta.push('<span class="ab-review__date">' + esc(dt) + '</span>');
    }
    if (meta.length)
      parts.push('<footer class="ab-review__meta">' + meta.join('<span class="ab-review__sep">·</span>') + '</footer>');

    // Connected product — the key feature the default testimonial lacks.
    if (opts.showProduct && product.shopify_handle) {
      var href = '/products/' + encodeURIComponent(product.shopify_handle);
      var imageUrl = safeImageUrl(product.image_url);
      var img = imageUrl
        ? '<img class="ab-review__product-image" src="' +
          esc(imageUrl) +
          '" alt="" loading="lazy" width="40" height="40">'
        : '';
      parts.push(
        '<a class="ab-review__product" href="' +
          href +
          '">' +
          img +
          '<span class="ab-review__product-name">' +
          esc(product.name || '') +
          '</span>' +
          '</a>'
      );
    }

    return '<article class="ab-review">' + parts.join('') + '</article>';
  }

  function hydrate(container) {
    if (container.hasAttribute('data-ab-reviews-ready')) return;
    container.setAttribute('data-ab-reviews-ready', '');

    var companyId = container.getAttribute('data-company-id');
    if (!companyId) return;

    var count = parseInt(container.getAttribute('data-count'), 10) || 12;
    var minRating = parseInt(container.getAttribute('data-min-rating'), 10) || 0;
    var requireText = container.getAttribute('data-require-text') === 'true';
    var opts = {
      showProduct: container.getAttribute('data-show-product') === 'true',
      showDate: container.getAttribute('data-show-date') === 'true',
    };

    // Optional collection allow-list (product handles from the section setting).
    // When set, only reviews for those products are shown — lets the merchant
    // exclude service products (repair/resize) or feature a curated set.
    var allowedRaw = container.getAttribute('data-allowed-handles') || '';
    var allowedHandles = allowedRaw
      ? allowedRaw.split(',').filter(function (h) {
          return h;
        })
      : [];
    var allowedSet = allowedHandles.length ? new Set(allowedHandles) : null;

    // Over-fetch so client-side filtering (rating / has-text / collection) still
    // yields `count` cards. A collection filter is the most restrictive, so pull
    // the API maximum when one is active.
    var fetchLimit = allowedSet ? 50 : Math.min(count * 3, 50);
    var url = ENDPOINT + '?company_id=' + encodeURIComponent(companyId) + '&limit=' + fetchLimit + '&offset=0&sort=3';

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('Klaviyo reviews ' + r.status);
        return r.json();
      })
      .then(function (data) {
        // The dynamic heading (overall rating + total review count) comes from the
        // API `summary`, not the individual reviews — so it reflects the whole store
        // regardless of the rating/has-text filters applied to the cards below.
        updateDynamicText(container, data && data.summary);
        var reviews = (data && data.reviews) || [];
        var filtered = reviews.filter(function (rv) {
          if (rv.rating < minRating) return false;
          if (requireText && !(rv.content && rv.content.trim())) return false;
          if (allowedSet) {
            var handle = rv.product && rv.product.shopify_handle;
            if (!handle || !allowedSet.has(handle)) return false;
          }
          return true;
        });
        render(container, filtered.slice(0, count), opts);
      })
      .catch(function (err) {
        // On failure, collapse the whole section rather than leaving an empty
        // heading + skeletons behind.
        if (window.console && console.warn) console.warn('[ab-reviews] load failed', err);
        collapseSection(container);
      });
  }

  // Fill the section heading/subheading from the live API summary. Each token-bearing
  // element carries a `data-template` with [rating] / [count] tokens; we swap them for
  // the real numbers and reveal it (it's kept hidden until now so raw tokens never flash).
  function updateDynamicText(container, summary) {
    var section = container.closest('.shopify-section');
    if (!section) return;
    var els = section.querySelectorAll('[data-ab-reviews-token]');
    if (!els.length) return;
    var rating = summary && typeof summary.star_rating === 'number' ? summary.star_rating.toFixed(1) : '';
    var countNum = summary && typeof summary.review_count === 'number' ? summary.review_count : null;
    var count = countNum == null ? '' : countNum.toLocaleString();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var tpl = el.getAttribute('data-template') || el.textContent || '';
      // The theme editor injects `<!-- BEGIN/END SETTING: ... -->` comments around any
      // `{{ section.settings.x }}` output, including inside this data-* attribute. Strip
      // them so they don't get read back and painted as literal text below.
      tpl = tpl.replace(/<!--\s*(?:BEGIN|END) SETTING:[\s\S]*?-->/g, '');
      el.textContent = tpl.replace(/\[rating\]/g, rating).replace(/\[count\]/g, count);
      el.classList.remove('ab-reviews__dynamic-text--pending');
    }
  }

  // Hide the entire section wrapper so a failed/empty fetch leaves no orphaned
  // heading, padding, or border on the page.
  function collapseSection(container) {
    var section = container.closest('.shopify-section');
    if (section) {
      section.style.display = 'none';
    } else {
      var track = container.querySelector('.ab-reviews__track');
      if (track) track.remove();
    }
  }

  function render(container, reviews, opts) {
    var track = container.querySelector('.ab-reviews__track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'ab-reviews__track';
      container.appendChild(track);
    }
    if (!reviews.length) {
      collapseSection(container);
      return;
    }
    track.removeAttribute('aria-busy');
    track.innerHTML = reviews
      .map(function (rv) {
        return cardHtml(rv, opts);
      })
      .join('');

    // The native <scroll-carousel> only recomputes `.is-scrollable` (which shows/
    // hides the prev/next controls) on resize. Injecting cards changes scrollWidth
    // but not the element's own box, so nudge the flag to match the real content.
    if (track.classList && typeof track.scrollWidth === 'number') {
      track.classList.toggle('is-scrollable', track.scrollWidth - track.clientWidth > 1);
    }
  }

  function init() {
    document.querySelectorAll('[data-ab-reviews]').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', init);
})();

// === Wishlist page: swap the remove "X" for a trash icon (KAN-31 item 2c) ===
// The remove button lives inside nested OPEN shadow roots
// (<ooo-wl-page-container> → <ooo-wl-page-product-card>), so theme CSS can't
// reach it (custom properties cross the boundary, plain selectors don't). We
// inject a tiny stylesheet into each product card's shadow root that hides the
// app's X glyph and paints a trash icon via a masked pseudo-element (inheriting
// the button colour set by --ooo-wl-...-remove-button-color). NOTE: this relies
// on the app's open shadow DOM structure — if Wishlist Power changes its markup,
// revisit this. The trash SVG is inline (no external Flaticon asset).
(function () {
  var TRASH_MASK =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M4 7h16'/%3E%3Cpath d='M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2'/%3E%3Cpath d='M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13'/%3E%3Cpath d='M10 11v6'/%3E%3Cpath d='M14 11v6'/%3E%3C/svg%3E\") center / contain no-repeat";

  // NOTE: do NOT set position on the button — the app already makes it
  // position:absolute at the card's top-right, and overriding it drops the
  // icon into normal flow (bottom-left). The ::after centres itself inside the
  // button's existing grid layout.
  var TRASH_CSS =
    '.ooo-wl-button-icon--delete{display:none!important;}' +
    "ooo-wl-page-product-card-remove-button button::after{content:'';display:block;" +
    'width:1.125rem;height:1.125rem;background-color:currentColor;' +
    '-webkit-mask:' +
    TRASH_MASK +
    ';mask:' +
    TRASH_MASK +
    ';}' +
    // Hover: same gold pulse as the share button. The trash glyph is painted
    // with currentColor, so animating `color` on the button recolors it.
    'ooo-wl-page-product-card-remove-button button{transition:color .4s ease;}' +
    'ooo-wl-page-product-card-remove-button button:hover{' +
    'animation:skbTrashGlow 2.8s ease-in-out infinite;}' +
    '@keyframes skbTrashGlow{' +
    '0%,100%{color:#bb9d7b;}' +
    '50%{color:#f0e2c4;}}' +
    // Desktop: the trash shows on hover, like the bookmark on product cards (custom.css).
    '@media screen and (hover:hover) and (pointer:fine){' +
    'ooo-wl-page-product-card-remove-button{opacity:0;transition:opacity .2s ease-in-out;}' +
    ':host(:hover) ooo-wl-page-product-card-remove-button,' +
    'ooo-wl-page-product-card-remove-button:focus-within{opacity:1;}}';

  // Wishlist page cards follow the theme product card (Theme settings > Product card): same frame,
  // colours, title and price type, arrow, and quick add style; the trash takes the wishlist icon's
  // spot. Built per card from the same --product-card-* custom properties custom.css uses (they
  // inherit across the shadow boundary). The app's variant picker is hidden: single-variant products
  // keep a quick add button, multi-variant products show none (the shopper picks a size on the PDP).
  function svgMask(markup) {
    if (!markup) return '';
    var svg = String(markup).replace(/currentColor/g, 'black');
    if (svg.indexOf('xmlns=') === -1) svg = svg.replace('<svg', "<svg xmlns='http://www.w3.org/2000/svg'");
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg).replace(/'/g, '%27') + '") center / contain no-repeat';
  }

  var PLUS_MASK = svgMask('<svg viewBox="0 0 12 12" fill="none"><path d="M6 0v12M0 6h12" stroke="black" stroke-width="1.5"/></svg>');
  var ARROW_BG =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M3 17 17 3M8 3h9v9' fill='none' stroke='%23bb9d7b' stroke-width='1'/%3E%3C/svg%3E\") center / contain no-repeat";

  function cardCss() {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var outlined = settings.productCardQuickAddStyle === 'outlined';
    var fp = 'var(--product-card-frame-padding,0px)';
    var ip = 'var(--product-card-info-padding-inline,0px)';
    var css =
      ':host{--product-card-qa-size:34px;' +
      '--ooo-wl-page-product-card-remove-button-inline-end:calc(' + ip + ' + (var(--product-card-qa-size) - 2.625rem) / 2);}' +
      // Card frame and image area
      '.ooo-wl-page-product-card{position:relative;container-type:inline-size;gap:0!important;padding:' + fp + ';' +
      'border:var(--product-card-frame-border,0);border-radius:var(--product-card-radius,0px);overflow:hidden;' +
      'background:var(--product-card-card-bg,transparent);}' +
      '.ooo-wl-page-product-card__image-container{border-radius:max(0px,calc(var(--product-card-radius,0px) - ' + fp + '));overflow:hidden;' +
      'background:var(--product-card-image-bg,var(--product-card-card-bg,transparent));}' +
      '.ooo-wl-page-product-card__image-container img{object-fit:contain;}' +
      // Text strip
      '.ooo-wl-page-product-card__info-container{position:static!important;display:flex!important;flex-direction:column!important;' +
      'align-items:var(--product-card-text-align,start)!important;justify-content:flex-start!important;gap:3px!important;' +
      'padding:13px ' + ip + ' ' + fp + '!important;text-align:var(--product-card-text-align,start)!important;' +
      'background:var(--product-card-bg,transparent);}' +
      '.ooo-wl-page-product-card__info-wrapper{width:100%;gap:0!important;justify-items:var(--product-card-text-align,start)!important;' +
      'align-items:var(--product-card-text-align,start)!important;text-align:inherit!important;}' +
      '.ooo-wl-page-product-card__price-container{justify-content:var(--product-card-text-align,start)!important;' +
      'align-items:baseline!important;text-align:inherit!important;}' +
      '[data-field="title"]{display:block;position:relative;width:100%;box-sizing:border-box;' +
      (settings.productCardTitleArrow === false ? '' : 'padding-inline-end:22px;') +
      'font-size:var(--text-base)!important;line-height:var(--leading-snug)!important;font-weight:400!important;' +
      'letter-spacing:0!important;text-transform:none!important;overflow-wrap:anywhere;' +
      'color:var(--product-card-title-color,inherit)!important;}' +
      (settings.productCardTitleArrow === false
        ? ''
        : '[data-field="title"]::after{content:"";position:absolute;inset-inline-end:0;top:2px;width:17px;height:17px;background:' + ARROW_BG + ';}') +
      '[data-field="price-container"]{margin-top:7px;gap:6px;}' +
      '[data-field="price"],[data-field="compare-at-price"]{font-size:var(--text-sm)!important;line-height:var(--leading-normal)!important;' +
      'color:var(--product-card-price-color,inherit)!important;}' +
      '[data-field="compare-at-price"]{opacity:.7;}' +
      // Stands in for the product card's rating row (28px), so card heights and the quick add spot match.
      '.ooo-wl-page-product-card__info-wrapper::after{content:"";display:block;height:28px;}' +
      // Add to cart: no variant picker; multi-variant products show no button
      '[data-field="variants-select-container"]{display:none!important;}' +
      'ooo-wl-page-product-card-form{margin:0!important;}' +
      'ooo-wl-page-product-card-form:has(select option:nth-child(3)){display:none!important;}' +
      'ooo-wl-page-product-card-form [data-field="form-button"]{position:absolute!important;display:grid!important;place-items:center!important;' +
      'min-height:0!important;padding:0!important;font-size:0!important;letter-spacing:0!important;z-index:2;}' +
      'ooo-wl-page-product-card-form [data-field="form-button"] [data-action="label"]{position:absolute!important;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);}' +
      // The app's loading dots sit over the icon instead of taking a grid cell beside it.
      'ooo-wl-page-product-card-form [data-field="form-button"] [data-action="loading"]{position:absolute!important;}' +
      // The app uses ::before for its own button effect; re-centre it for the icon.
      'ooo-wl-page-product-card-form [data-field="form-button"]::before{content:"";display:block;position:absolute!important;inset:0!important;' +
      'margin:auto!important;transform:none!important;opacity:1!important;background-color:currentColor!important;}';
    if (outlined) {
      css +=
        // Round outline with the header cart icon, bottom right of the text strip
        '.ooo-wl-page-product-card__info-container:has(ooo-wl-page-product-card-form:not([hidden])) .ooo-wl-page-product-card__price-container{padding-inline-end:40px;}' +
        'ooo-wl-page-product-card-form [data-field="form-button"]{' +
        'inset-block-end:calc(max(0.65rem,' + fp + ') + ' + fp + ')!important;inset-inline-end:calc(' + fp + ' + ' + ip + ')!important;' +
        'width:var(--product-card-qa-size)!important;height:var(--product-card-qa-size)!important;' +
        'border:1px solid rgb(var(--text-color) / .25)!important;border-radius:999px!important;background:transparent!important;' +
        'color:var(--product-card-price-color,rgb(var(--text-color)))!important;transition:border-color .2s ease!important;}' +
        'ooo-wl-page-product-card-form [data-field="form-button"]::before{width:16px;height:16px;' +
        '-webkit-mask:' + svgMask(settings.productCardQuickAddIcon) + ';mask:' + svgMask(settings.productCardQuickAddIcon) + ';}' +
        'ooo-wl-page-product-card-form [data-field="form-button"]:hover{border-color:var(--color-accent,currentColor)!important;}';
    } else {
      css +=
        // The theme's original plus: square, bottom right of the image, shown on hover on desktop
        'ooo-wl-page-product-card-form [data-field="form-button"]{' +
        'top:calc(' + fp + ' + 100cqw - 0.5rem - 2rem)!important;inset-inline-end:calc(' + fp + ' + 0.5rem)!important;' +
        'width:2rem!important;height:2rem!important;border:0!important;border-radius:0!important;' +
        'background:var(--color-accent,rgb(187 157 123))!important;color:rgb(255 255 255)!important;}' +
        'ooo-wl-page-product-card-form [data-field="form-button"]::before{width:12px;height:12px;-webkit-mask:' + PLUS_MASK + ';mask:' + PLUS_MASK + ';}' +
        '@media screen and (pointer:fine){ooo-wl-page-product-card-form [data-field="form-button"]{opacity:0;transform:translateY(5px);' +
        'transition:opacity .2s ease-in-out,transform .2s ease-in-out!important;}' +
        ':host(:hover) ooo-wl-page-product-card-form [data-field="form-button"],' +
        'ooo-wl-page-product-card-form [data-field="form-button"]:focus{opacity:1;transform:none;}}';
    }
    css +=
      '@media screen and (max-width:760px){:host{--product-card-qa-size:30px;}' +
      '.ooo-wl-page-product-card__info-container{padding-top:8px!important;gap:0!important;}' +
      '[data-field="title"]{font-size:var(--text-sm)!important;}' +
      '[data-field="price-container"]{margin-top:5px;}' +
      '.ooo-wl-page-product-card__info-wrapper::after{height:24px;}}';
    return css;
  }

  function injectInto(root) {
    if (!root || root.querySelector('style[data-wl-trash]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-wl-trash', '');
    var css = TRASH_CSS + cardCss();
    style.textContent = css;
    root.appendChild(style);
  }

  // The wishlist bar's Share button drives the app's share control, so the
  // app's own button stays in the page (clickable) but visually hidden.
  function hideAppShareButton(containerRoot) {
    if (containerRoot.querySelector('style[data-wl-share-hidden]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-wl-share-hidden', '');
    style.textContent =
      'ooo-wl-page-content-info[template="ooo-wl-page-share-wishlist"]{' +
      'position:absolute!important;width:1px!important;height:1px!important;' +
      'overflow:hidden!important;clip-path:inset(50%)!important;' +
      'white-space:nowrap!important;margin:0!important;padding:0!important;}';
    containerRoot.appendChild(style);
  }

  // Hover animation for the share button, injected into the share element's OWN
  // shadow root (where the button lives). On hover the letters/icon gently pulse
  // between gold tones (dark gold -> light cream -> back). currentColor +
  // text-fill-color cover whichever the app uses to paint the glyphs.
  // Background/border stay untouched.
  var SHARE_BUTTON_CSS =
    'ooo-wl-page-share-button{transition:color .4s ease;}' +
    'ooo-wl-page-share-button:hover{animation:skbShareGlow 2.8s ease-in-out infinite;}' +
    '@keyframes skbShareGlow{' +
    '0%,100%{color:#bb9d7b;-webkit-text-fill-color:#bb9d7b;}' +
    '50%{color:#f0e2c4;-webkit-text-fill-color:#f0e2c4;}}';

  // "Link copied!" confirmation: the app renders it as a <span> with a green
  // background (rgb(24,113,48)) and white text/tick, only in the copied state
  // (that span holds the .ooo-wl-button-icon--tick icon). Recolor its background
  // to the brand gold; text stays white. :has() targets only the copied span so
  // the normal "Share your wishlist" state is untouched.
  // color + -webkit-text-fill-color both forced white: the hover glow animates
  // text-fill on the button and it inherits into this span, so without pinning
  // text-fill here the "Link copied!" text would pulse gold over the gold bg.
  var SHARE_COPIED_CSS =
    'ooo-wl-copy-button button span:has(.ooo-wl-button-icon--tick){' +
    'background:var(--color-accent,#bb9d7b)!important;' +
    'background-color:var(--color-accent,#bb9d7b)!important;' +
    'color:#fff!important;-webkit-text-fill-color:#fff!important;}';

  function injectShareStyle(root, css) {
    if (!root || root.querySelector('style[data-wl-share-style]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-wl-share-style', '');
    style.textContent = css;
    root.appendChild(style);
  }

  function styleShareButton(containerRoot) {
    var share = containerRoot.querySelector('ooo-wl-page-content-info[template="ooo-wl-page-share-wishlist"]');
    if (!share || !share.shadowRoot) return;
    var css = SHARE_BUTTON_CSS + SHARE_COPIED_CSS;
    injectShareStyle(share.shadowRoot, css);
    // The copied-confirmation span may sit in a nested shadow root — inject there too.
    var btn = share.shadowRoot.querySelector('ooo-wl-page-share-button');
    if (btn && btn.shadowRoot) injectShareStyle(btn.shadowRoot, css);
    var scope = btn && btn.shadowRoot ? btn.shadowRoot : share.shadowRoot;
    var copy = scope.querySelector('ooo-wl-copy-button');
    if (copy && copy.shadowRoot) injectShareStyle(copy.shadowRoot, css);
  }

  // Empty state: hidden (custom.css also collapses it via the app's variables,
  // so it never paints). The wishlist bar carries the page's message.
  var EMPTY_STATE_CSS =
    '.ooo-wl-page-empty__title,.ooo-wl-page-empty__description{color:var(--color-text,#fff)!important;}' +
    '.ooo-wl-page-empty{display:none!important;}';

  function styleEmptyState(containerRoot) {
    containerRoot.querySelectorAll('ooo-wl-page-content-info').forEach(function (info) {
      var root = info.shadowRoot;
      if (!root || root.querySelector('style[data-wl-empty-style]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-wl-empty-style', '');
      style.textContent = EMPTY_STATE_CSS;
      root.appendChild(style);
    });
  }

  function injectAll() {
    var container = document.querySelector('ooo-wl-page-container');
    if (!container || !container.shadowRoot) return false;
    hideAppShareButton(container.shadowRoot);
    styleShareButton(container.shadowRoot);
    styleEmptyState(container.shadowRoot);
    container.shadowRoot.querySelectorAll('ooo-wl-page-product-card').forEach(function (card) {
      if (card.shadowRoot) injectInto(card.shadowRoot);
    });
    return true;
  }

  var observing = false;
  var observed = null;
  function ensureObserver() {
    var container = document.querySelector('ooo-wl-page-container');
    if (observing && container === observed) return;
    if (!container || !container.shadowRoot || !('MutationObserver' in window)) return;
    observing = true;
    observed = container;
    // Re-inject when cards are (re)rendered, e.g. on pagination. Observing the
    // container's shadow root only — a card's own shadow root is a separate
    // tree, so our injected <style> never retriggers this.
    new MutationObserver(injectAll).observe(container.shadowRoot, {
      childList: true,
      subtree: true,
    });
    injectAll();
  }

  // Cards render asynchronously; poll until the container shadow root exists,
  // then hand off to the observer. Give up after ~12s.
  var tries = 0;
  var timer;
  function startPolling() {
    clearInterval(timer);
    tries = 0;
    timer = setInterval(function () {
      injectAll();
      ensureObserver();
      if ((observing && observed === document.querySelector('ooo-wl-page-container')) || ++tries > 48) clearInterval(timer);
    }, 250);
  }
  startPolling();
  document.addEventListener('skb:wl-remounted', startPolling); // listing re-mounted by the wishlist bar
})();

/* ============================================================
   LOAD MORE PAGINATION
   ============================================================ */
(function () {
  // Use event delegation so re-renders from facet filtering don't need re-init
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;

    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl || btn.disabled) return;

    btn.disabled = true;

    fetch(nextUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var listId = btn.getAttribute('data-product-list-id');
        var targetList = document.getElementById(listId);
        var sourceList = doc.getElementById(listId);

        if (!targetList || !sourceList) return;

        Array.from(sourceList.children).forEach(function (child) {
          targetList.appendChild(document.importNode(child, true));
        });

        var newBtn = doc.querySelector('[data-load-more-btn]');
        var wrapper = btn.closest('[data-load-more-wrapper]');

        if (newBtn) {
          var newNextUrl = newBtn.getAttribute('data-next-url');
          var newCount = newBtn.getAttribute('data-current-count');
          btn.setAttribute('data-next-url', newNextUrl);
          btn.setAttribute('data-current-count', newCount);
          btn.disabled = false;

          var showCount = btn.getAttribute('data-show-count') === 'true';
          if (showCount && wrapper) {
            var countEl = wrapper.querySelector('[data-load-more-count]');
            if (countEl) {
              var total = btn.getAttribute('data-total-count');
              // Translated sentence with __shown__/__total__ sentinels, injected by
              // main-collection.liquid so no English is hard-coded here. If it is
              // missing, clear the text rather than leaving the previous page's
              // count on screen, which would read as a wrong number.
              var template = btn.getAttribute('data-count-template');
              countEl.textContent = template
                ? template.replace('__shown__', newCount).replace('__total__', total)
                : '';
            }
          }
        } else {
          // No more pages — hide the wrapper
          if (wrapper) wrapper.style.display = 'none';
        }
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();

// === Wishlist buttons: remove the white load flash (KAN-31 1d/3b) ===
// Both <ooo-wl-product-page-button> (product page) and <ooo-wl-product-card-button>
// (collection/product cards) render their real <button> inside a shadow root
// whose stylesheet is an async <link>; for one frame the button paints with the
// browser's default white background before the styled state applies. custom.css
// keeps the wrapper invisible until we add .skb-wl-ready, which we do once that
// shadow stylesheet has actually loaded — so it reveals already styled.
(function () {
  var TAGS = ['ooo-wl-product-page-button', 'ooo-wl-product-card-button'];
  var SELECTOR = TAGS.join(',');

  function revealWhenStyled(el) {
    if (el.__skbFoucDone) return;
    var root = el.shadowRoot;
    if (!root) return; // not upgraded yet — a later scan will catch it
    el.__skbFoucDone = true;

    var reveal = function () {
      el.classList.add('skb-wl-ready');
    };
    var link = root.querySelector('link[rel="stylesheet"]');

    if (!link || link.sheet) {
      reveal(); // no external sheet, or it's already applied
    } else {
      link.addEventListener('load', reveal, { once: true });
      link.addEventListener('error', reveal, { once: true });
      setTimeout(reveal, 4000); // safety net: never stay hidden for good
    }
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(revealWhenStyled);
  }

  function init() {
    scan();
    if (window.customElements && customElements.whenDefined) {
      TAGS.forEach(function (t) {
        customElements
          .whenDefined(t)
          .then(scan)
          .catch(function () {});
      });
    }
    // Global fail-safe: if the app never upgrades the elements (e.g. it fails to
    // load), reveal anyway after 5s so the buttons are never hidden permanently.
    setTimeout(function () {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add('skb-wl-ready');
      });
    }, 5000);
    // The product info block re-renders on variant change, recreating the
    // button — re-scan (debounced) so the new instance is handled too.
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(scan, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// === Wishlist page bar (sections/ab-wishlist-bar.liquid) ===
// Share: logged in -> clicks the app's copy button + shows a toast;
// logged out -> the theme modal opens via aria-controls.
// Live refresh: the app fires ooo-wishlist:product-added/-removed when the
// wishlist changes elsewhere (e.g. cart drawer); we re-mount the listing so it
// fetches again. Changes made inside the listing are left to the app.
(function () {
  var bar = document.querySelector('[data-ab-wl-bar]');
  if (!bar) return;
  var shareBtn = bar.querySelector('[data-ab-wl-share]');
  var toast = bar.querySelector('[data-ab-wl-toast]');
  var SHARE_SEL = 'ooo-wl-page-content-info[template="ooo-wl-page-share-wishlist"]';

  function container() {
    return document.querySelector('ooo-wl-page-container');
  }

  // Depth-first search through nested open shadow roots.
  function deepFind(root, selector) {
    if (!root) return null;
    var hit = root.querySelector(selector);
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        hit = deepFind(all[i].shadowRoot, selector);
        if (hit) return hit;
      }
    }
    return null;
  }

  function appShare() {
    var c = container();
    return c && c.shadowRoot ? c.shadowRoot.querySelector(SHARE_SEL) : null;
  }

  function syncShare() {
    if (shareBtn) shareBtn.hidden = !appShare();
  }

  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      if (shareBtn.hasAttribute('aria-controls')) return;
      var share = appShare();
      var root = share && share.shadowRoot;
      var copy = root ? deepFind(root, 'ooo-wl-copy-button') : null;
      if (copy) {
        var copyTarget = (copy.shadowRoot && copy.shadowRoot.querySelector('button')) || copy.querySelector('button') || copy;
        copyTarget.click();
        showToast(toast.getAttribute('data-copied'));
        return;
      }
      showToast(toast.getAttribute('data-failed'));
    });
  }

  // Keep the Share button in step with the listing (empty <-> has products).
  var watched = null;
  var mo = 'MutationObserver' in window ? new MutationObserver(syncShare) : null;
  function watch() {
    var c = container();
    if (c && c.shadowRoot && c !== watched && mo) {
      mo.disconnect();
      mo.observe(c.shadowRoot, { childList: true, subtree: true });
      watched = c;
    }
    syncShare();
  }
  // The app renders asynchronously: poll briefly until its shadow root exists.
  var poll;
  function startWatching() {
    var tries = 0;
    clearInterval(poll);
    poll = setInterval(function () {
      watch();
      if (watched === container() || ++tries > 60) clearInterval(poll);
    }, 250);
  }
  startWatching();

  var refreshTimer;
  function remount() {
    var c = container();
    if (!c) return;
    c.replaceWith(c.cloneNode(false)); // the app rebuilds the listing on connect
    document.dispatchEvent(new CustomEvent('skb:wl-remounted'));
    startWatching();
  }
  function onChange(e) {
    var c = container();
    var path = e.composedPath ? e.composedPath() : [];
    if (c && path.indexOf(c) !== -1) return; // changed from the listing itself
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(remount, 600); // give the app time to save first
  }
  ['ooo-wishlist:product-added', 'ooo-wishlist:product-removed'].forEach(function (name) {
    document.addEventListener(name, onChange);
  });
})();

// === Product page: place the wishlist icon beside ADD TO CART (KAN-31 item 5) ===
// The Wishlist Power app block renders as its own stacked block below the buy
// buttons. The brief wants the (icon-only) button on the SAME ROW as ADD TO
// CART, to its right. Rather than fight the block layout with fragile negative
// margins, we move the app's <ooo-wl-access-button> INTO <buy-buttons> so they
// share one flex row (custom.css styles .buy-buttons--with-wishlist). Moving the
// node preserves the app element (variant handling, added-state) intact. We
// re-apply after Prestige re-renders the product info on variant change.
(function () {
  var SECTION = '.shopify-section--main-product';

  function place() {
    var section = document.querySelector(SECTION);
    if (!section) return;
    var buyButtons = section.querySelector('buy-buttons');
    var wishlist = section.querySelector('ooo-wl-access-button');
    if (!buyButtons || !wishlist || buyButtons.contains(wishlist)) return;
    buyButtons.appendChild(wishlist);
    buyButtons.classList.add('buy-buttons--with-wishlist');
  }

  function init() {
    // PERF: bail on any page that has no product section. Without this the interval
    // below still scheduled 41 main-thread wakeups over 10 seconds on every home,
    // collection, cart, search and article page, each one calling place() only for it
    // to return on its first line.
    //
    // Provably the same behaviour: place() already opens with this exact query and
    // returns when it misses, and the MutationObserver further down is guarded by the
    // same check, so on a page without the section nothing happened before either.
    // Sections are server-rendered and init runs at DOMContentLoaded, and nothing here
    // listens for shopify:section:load, so the section cannot appear after this point.
    if (!document.querySelector(SECTION)) return;

    place();
    // App + Prestige render asynchronously; retry briefly until both exist.
    var tries = 0;
    var timer = setInterval(function () {
      place();
      if (++tries > 40) clearInterval(timer);
    }, 250);

    // Prestige rebuilds the product info on variant change, which resets the
    // node back to its own block, so this has to keep re-placing it.
    //
    // KAN-192: observe document.body, not the section. theme.js replaces the whole
    // product section on a variant change, so a node captured here is detached the
    // moment that happens: the observer stays alive and keeps firing against a tree
    // nobody is looking at, and the button never comes back. document.body outlives
    // every re-render, and place() re-queries the section each time anyway, so it
    // always works on the current one.
    //
    // Coalesced with requestAnimationFrame rather than a timeout: place()'s own
    // appendChild is a mutation inside the observed tree, and the next pass sees the
    // button already inside <buy-buttons> and returns on its guard, so the cascade
    // stops after one extra frame.
    if ('MutationObserver' in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          place();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// === Header: show the wishlist link only when the Wishlist Power app is on ===
// The header bookmark is hardcoded in the theme (sections/header.liquid), so it
// would otherwise show even when the merchant disables the Wishlist Power app
// embed. custom.css hides .header__wishlist-link by DEFAULT; we add .skb-wl-active
// only once the app's setup embed has loaded (window.Maestrooo). So when the
// embed is OFF the icon never appears (no flash); when it's ON the icon reveals
// as soon as the app loads. Hidden-by-default avoids the show-then-hide flash.
(function () {
  var link = document.querySelector('.header__wishlist-link');
  if (!link) return;
  // Toggle the class on the <ooo-wl-access-button> WRAPPER (the flex child of
  // the header nav) so hiding it leaves no empty gap; fall back to the link.
  var wrap = link.closest('ooo-wl-access-button') || link;

  function reveal() {
    wrap.classList.add('skb-wl-active');
  }

  if (window.Maestrooo) {
    reveal();
    return;
  }
  // Poll briefly for the app; if it never loads, the embed is off → stays hidden.
  var tries = 0;
  var timer = setInterval(function () {
    if (window.Maestrooo) {
      reveal();
      clearInterval(timer);
    } else if (++tries >= 40) {
      clearInterval(timer); // ~10s with no app → leave hidden
    }
  }, 250);
})();

// === Rich Text: "Read more" expandable text (KAN-113) ===
// Opt-in per section (sections/rich-text.liquid). The content is collapsed to a
// set height with a fade; we reveal the toggle + fade ONLY when the content
// actually overflows that height, then toggle .is-expanded on click.
(function () {
  function initReadMore(el) {
    if (el.__rtReadMore) return;
    el.__rtReadMore = true;

    var content = el.querySelector('.rt-readmore__content');
    var toggle = el.querySelector('.rt-readmore__toggle');
    if (!content || !toggle) return;

    var moreLabel = el.getAttribute('data-more') || 'Read more';
    var lessLabel = el.getAttribute('data-less') || 'Read less';

    function collapsedHeight() {
      return parseFloat(getComputedStyle(el).getPropertyValue('--rt-collapsed-height')) || 160;
    }

    // Only show the toggle/fade when the content is taller than the collapsed
    // height; shorter content shows in full (max-height doesn't clip it).
    function measure() {
      var overflowing = content.scrollHeight > collapsedHeight() + 4;
      el.classList.toggle('has-overflow', overflowing);
      if (overflowing) {
        toggle.hidden = false;
      } else {
        toggle.hidden = true;
        el.classList.remove('is-expanded');
      }
    }

    toggle.addEventListener('click', function () {
      var expanded = el.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? lessLabel : moreLabel;
    });

    measure();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(measure, 150);
    });
    // Re-measure once webfonts finish loading (line height can shift).
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  function init() {
    document.querySelectorAll('[data-rt-readmore]').forEach(initReadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when the section is (re)rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();

// === Collection quiz — progressive filter wizard (sections/collection-quiz.liquid) ===
// One question is visible at a time. Picking an answer merges its filter
// query params into the collection's current filters and dispatches the
// same `facet:update` event the native facets engine listens for
// (assets/theme.js), so results refresh through the existing AJAX/Section
// Rendering API path — no full page reload. An answer left without filter
// params ("show me everything") just advances to the next question.
(function () {
  if (window.customElements.get('collection-quiz')) return;

  // Question block IDs already answered. Deliberately kept in module scope
  // rather than on the element: theme.js's facet:update handler swaps the
  // whole collection section via replaceChildren (Section Rendering API), so
  // this element is destroyed and rebuilt from server markup on every filter
  // — and that markup always flags the FIRST question active. Holding this
  // out here lets the rebuilt element restore the right question, while a
  // genuine page load re-runs this script and starts the quiz over.
  //
  // Tracked by block ID, not by index: the section drops answers (and whole
  // questions) whose filters would return no products, so a question's
  // position shifts between renders and an index would point at the wrong one.
  var answeredQuestionIds = [];

  // Same lookup assets/theme.js's facet:update handler relies on
  // (`shopifySection.querySelector(".collection")`) — the product grid
  // section always has this element, whether or not filters are enabled.
  function getMainCollectionSectionId() {
    var el = document.querySelector('.collection');
    var section = el && el.closest('.shopify-section');
    return section && section.id.replace('shopify-section-', '');
  }

  // After every facet update theme.js scrolls the product grid to the top of
  // the viewport (`.collection`.scrollIntoView). That's right for the filter
  // bar, but for the quiz it pushes the next question off-screen. Swallow that
  // one scroll by patching scrollIntoView just for the grid element, for the
  // duration of the update — filter-bar clicks never go through here, so their
  // scroll behaviour is untouched.
  function suppressNextGridScroll() {
    if (Element.prototype.scrollIntoView.__quizPatched) return;

    var original = Element.prototype.scrollIntoView;

    function restore() {
      Element.prototype.scrollIntoView = original;
    }

    function patched() {
      if (this.classList && this.classList.contains('collection')) {
        restore();
        return;
      }
      return original.apply(this, arguments);
    }

    patched.__quizPatched = true;
    Element.prototype.scrollIntoView = patched;
    // Fail-safe: never leave the prototype patched if the fetch fails or a
    // future theme version stops scrolling here.
    setTimeout(restore, 2000);
  }

  function hasActiveFilters() {
    var params = new URLSearchParams(window.location.search);
    var found = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) found = true;
    });
    return found;
  }

  window.customElements.define('collection-quiz', class extends HTMLElement {
    connectedCallback() {
      // "Clear all" (and removing the last active filter chip) means the visitor
      // is starting over, so the quiz has to go back to question one. Those go
      // through the same AJAX section swap as everything else — there's no page
      // load to reset on — so detect the empty-filter state from the URL, which
      // theme.js has already updated via history.replaceState by this point.
      if (!hasActiveFilters()) {
        answeredQuestionIds = [];
      }

      this.showCurrentStep();
      this.addEventListener('click', this.onAnswerClick.bind(this));
    }

    showCurrentStep() {
      var questions = Array.prototype.slice.call(this.querySelectorAll('.collection-quiz__question'));
      var next = null;

      for (var i = 0; i < questions.length; i++) {
        if (answeredQuestionIds.indexOf(questions[i].dataset.questionId) === -1) {
          next = questions[i];
          break;
        }
      }

      questions.forEach(function (question) {
        question.classList.toggle('is-active', question === next);
      });

      // Nothing left unanswered — hide the quiz so the filtered grid takes over.
      this.classList.toggle('is-complete', next === null);
    }

    onAnswerClick(event) {
      // KAN-142: the answers row is a draggable carousel, and the theme cancels
      // the click that ends a drag rather than stopping it propagating. Without
      // this guard, dragging to the next pair of answers would also pick whichever
      // answer the drag happened to start on.
      if (event.defaultPrevented) return;

      var btn = event.target.closest('.collection-quiz__answer');
      if (!btn) return;

      // Mark answered before dispatching: the section may be replaced as soon
      // as the fetch resolves, and the fresh element reads this on connect.
      var question = btn.closest('.collection-quiz__question');
      var questionId = question && question.dataset.questionId;
      if (questionId && answeredQuestionIds.indexOf(questionId) === -1) {
        answeredQuestionIds.push(questionId);
      }

      // The skip control ships with empty filter params, so it falls through the
      // "show me everything" path below on its own: mark the question answered,
      // move to the next, touch no filters.
      var answerParams = (btn.dataset.filterParams || '').trim();
      var sectionId = answerParams ? getMainCollectionSectionId() : null;

      if (!sectionId) {
        // "Show me everything" answer (or no grid to target): nothing to
        // filter, just move to the next question in place.
        this.showCurrentStep();
        return;
      }

      var params = new URLSearchParams(window.location.search);
      params.delete('section_id');
      new URLSearchParams(answerParams).forEach(function (value, key) {
        params.append(key, value);
      });
      params.set('section_id', sectionId);

      var url = new URL(window.location.pathname, window.location.origin);
      url.search = params.toString();

      suppressNextGridScroll();
      btn.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url: url } }));
    }
  });
})();

// === Collection quiz — animate the answer carousel when an arrow is used ===
// The theme already asks for a smooth scroll (ScrollCarousel.select passes
// behavior: "smooth"), but scroll-snap-type: mandatory makes the browser discard
// the animation and jump straight to the snap position. The theme hits the same
// problem on mouse drags and works around it by turning snapping off for the
// duration; the arrow path never got that treatment.
//
// Hooking the carousel's own carousel:select rather than the buttons means this
// covers any programmatic move, not just a click on the arrow. The event does not
// bubble, so it is caught in the capture phase — that still fires for ancestors.
(function () {
  var SNAP_RESTORE_FALLBACK_MS = 700;

  document.addEventListener(
    'carousel:select',
    function (event) {
      var carousel = event.target;
      if (!carousel.classList || !carousel.classList.contains('collection-quiz__answers')) return;

      carousel.style.setProperty('scroll-snap-type', 'none');

      var restored = false;
      function restoreSnap() {
        if (restored) return;
        restored = true;
        carousel.style.removeProperty('scroll-snap-type');
      }

      // scrollend is the real signal; the timeout is a backstop so snapping can
      // never be left switched off if the event is missed or the scroll is
      // interrupted mid-flight.
      carousel.addEventListener('scrollend', restoreSnap, { once: true });
      setTimeout(restoreSnap, SNAP_RESTORE_FALLBACK_MS);
    },
    true
  );
})();


// === LimeSpot: translate the strings the app writes into its own widgets (KAN-182) ===
// LimeSpot renders box titles and every label inside its widgets from its own Designer,
// and the app has no translation feature, so all of it stayed English on every market.
// KAN-170 is about getting app content to where Shopify's translation layer can reach it.
//
// This replaces text and nothing else. The reverted commit earlier in this branch tried
// rendering our own heading in a real section and hiding LimeSpot's with CSS; on the
// preview their box laid itself out on top of the words, because their stylesheet and the
// theme's .section-header width cap interact in ways reading the repo does not predict.
// Their elements, their layout, their styling - only the words change, so in English the
// page is pixel-identical.
//
// Every replacement is keyed by the English the app currently renders, declared in
// js-variables.liquid. Two consequences worth knowing: the store's twelve boxes are
// covered without having to know each one's internal box type, and a title someone edits
// in the Designer simply stops being translated rather than being overwritten with a
// translation of different words.
//
// Two kinds of rule, because not every string is fixed:
//   map      - exact match, for labels that never vary.
//   patterns - a regex whose capture groups come back as [1], [2] in the replacement,
//              for the labels that carry a number or a product name. Kai's request
//              covered "the rest of the section", and the counted labels are the ones a
//              plain lookup table silently misses: the bundle button reads
//              "Add Selected to Cart" with nothing chosen and "Add 3 items to Cart:"
//              once something is, and the mobile bundle has its own "Buy all 3 items".
// Exact matches are tried first, so "Add bundle to cart" is taken by the map and never
// falls through to the "Add (.+) to cart" pattern that covers the product cards.
//
// Read off the live DOM rather than guessed - captured from a product page and from the
// cart drawer, which is a different box (CrossSell, slider layout) with a whole set of
// slider controls the product page does not render:
//   <h3 class="ls-box-title">Complete the Look</h3>
//   <span class="ls-bundle-price-text">Total Price:</span>
//   <button class="ls-bundle-add-to-cart" aria-label="Add bundle to cart">Add Selected to Cart</button>
//   <span class="ls-bundle-mobile-compact__button-text">Buy all 3 items</span>
//   <a class="ls-bundle-add-to-cart-select">Add 3 items to Cart:<span>...</span></a>
//   <div class="ls-custom-flag">New</div>
//   <span class="ls-sr-only">Brand:</span>
//   <input class="ls-checkbox" aria-label="Include PRODUCT in bundle">
//   <button class="ls-button--select ls-add-to-cart" aria-label="Add PRODUCT to cart">
//   <div class="ls-gallery" aria-label="Product gallery">
//   <div class="ls-slide-show-dots" aria-label="Slide 1 of 6">
//   <button class="ls-slide-show-dots__item" aria-label="Go to slide 2">
//   <button class="ls-slide-show-arrows__button" aria-label="Next slide">
//   <button class="variant-arrow" aria-label="Next variants">
//
// The aria-labels are worth as much as the visible text here, and on the product page
// they are worth more: custom.css deliberately collapses the Related and RecentViews
// add-to-cart buttons to a 35px "+" icon with font-size 0, so the only label a screen
// reader has left on those cards is the aria-label.
//
// The uppercase in Kai's ticket is text-transform in LimeSpot's stylesheet, not content.
//
// Still out of reach, and not fixable from the theme: bundleThisItemLabel, which LimeSpot
// injects as a CSS custom property rather than as text, and the "{{price}}" title on the
// cart drawer box, which is an unresolved template token in their own Designer config -
// that one is a fix in the app's panel.
(function () {
  var rules =
    (window.themeVariables &&
      window.themeVariables.strings &&
      window.themeVariables.strings.limespotStrings) ||
    null;
  if (!rules || !rules.length) return;

  // [1], [2] ... stand for the pattern's capture groups, so a product name or an item
  // count survives translation while the words around it change. Done with split/join
  // rather than a replacement regex, so a translation containing a dollar sign cannot be
  // read as a replacement pattern.
  function expand(template, match) {
    var out = template;
    for (var n = 1; n < match.length; n++) {
      out = out.split('[' + n + ']').join(match[n] === undefined ? '' : match[n]);
    }
    return out;
  }

  // Patterns arrive as source strings and are compiled once, on first use, rather than
  // rebuilt per node on every pass.
  function compile(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      out.push({ re: new RegExp(list[i].re), to: list[i].to });
    }
    return out;
  }

  // The replacement for a string, or null when nothing applies.
  function translate(value, map, patterns) {
    var current = value.trim();
    if (!current) return null;

    if (map) {
      var mapped = map[current];
      if (mapped) return mapped === current ? null : mapped;
    }

    if (patterns) {
      for (var i = 0; i < patterns.length; i++) {
        var m = current.match(patterns[i].re);
        if (m) {
          var next = expand(patterns[i].to, m);
          return next === current ? null : next;
        }
      }
    }

    return null;
  }

  function apply() {
    // One cheap query before fourteen document-wide ones. Watching aria-label means a
    // pass can be scheduled by any carousel on the page, including the theme's own, so
    // pages and moments with no LimeSpot widget in them cost a single failed lookup
    // instead of a full sweep. Every element these rules target sits inside a
    // limespot-box - the cart drawer box included, that is its root element too.
    if (!document.querySelector('limespot-box')) return;

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];

      if (rule.patterns && !rule.compiledText) rule.compiledText = compile(rule.patterns);
      if (rule.ariaPatterns && !rule.compiledAria) rule.compiledAria = compile(rule.ariaPatterns);

      var nodes = document.querySelectorAll(rule.selector);

      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];

        // Write to the text node, not to the element's textContent. Some of these carry
        // element children alongside their label - .ls-bundle-add-to-cart-select wraps a
        // nested span holding the price - and assigning textContent would delete that
        // markup. The whitespace around the label is put back untouched, because
        // LimeSpot's sr-only spans pad their text with it.
        if (rule.map || rule.compiledText) {
          var children = node.childNodes;

          for (var k = 0; k < children.length; k++) {
            var child = children[k];
            if (child.nodeType !== 3) continue;

            var raw = child.nodeValue;
            var next = translate(raw, rule.map, rule.compiledText);
            if (next === null) continue;

            var trimmed = raw.trim();
            var start = raw.indexOf(trimmed);
            child.nodeValue = raw.slice(0, start) + next + raw.slice(start + trimmed.length);
          }
        }

        if (rule.aria || rule.compiledAria) {
          var label = node.getAttribute('aria-label');

          if (label) {
            var nextLabel = translate(label, rule.aria, rule.compiledAria);
            if (nextLabel !== null) node.setAttribute('aria-label', nextLabel);
          }
        }
      }
    }
  }

  // The widgets arrive over the network, and a variant change or a cart update brings
  // more, so this cannot be a one-shot. One observer, coalesced into a single pass per
  // frame so a burst of mutations does not become a burst of full-document queries, and
  // disconnected once the page has been quiet long enough that anything still to come
  // would be a fresh navigation anyway.
  //
  // aria-label is watched as well as the tree, because the slider rewrites its own
  // "Slide 1 of 6" every time it advances. Our own writes do retrigger the observer, but
  // the value we leave behind matches no key and no pattern, so the following pass
  // changes nothing and the cascade stops one frame later. On the English storefront it
  // never starts: the expansion equals the text already there, translate returns null,
  // and nothing is written at all.
  //
  // No need to mark processed nodes, for the same reason.
  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  apply();

  var observer = new MutationObserver(schedule);
  var idleTimer = null;

  // Watching is re-armable rather than one-shot. The window still closes, so the page does
  // not carry a whole-document observer for the life of the visit, but anything that can
  // put a fresh LimeSpot box on the page opens it again.
  function watch(duration) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label'],
    });

    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      idleTimer = null;
      observer.disconnect();
    }, duration);
  }

  watch(20000);

  // KAN-182: the cart drawer is what the single window missed, and Kai reported it as
  // "the other section work with the translation, these two doesn't".
  //
  // Its cross-sell box only exists once the shopper opens the drawer, which is almost
  // always more than twenty seconds into a visit, so by then the observer had already
  // disconnected and the box rendered in English. Worse, the theme replaces the drawer's
  // children outright on every cart change (CartDrawer#replaceContent in theme.js), so a
  // box translated earlier came back English anyway.
  //
  // dialog:after-show does not bubble - it is dispatched on the dialog itself - so it is
  // caught in the capture phase, which runs on ancestors for non-bubbling events too. It
  // fires for every dialog in the theme, hence the check for the drawer: a quick-buy modal
  // holds the theme's own cards, which are already translated server-side.
  function rearm() {
    apply();
    watch(8000);
  }

  ['cart:change', 'cart:refresh', 'cart-drawer:refreshed'].forEach(function (name) {
    document.addEventListener(name, rearm);
  });

  document.addEventListener(
    'dialog:after-show',
    function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('cart-drawer')) rearm();
    },
    true,
  );
})();

// === Back in stock: subscribe the visitor through Klaviyo's client API (KAN-35) ===
// The "Notify me" button and its form are the theme's own (snippets/back-in-stock.liquid),
// so every string sits in locales/ and the button is the same outline button as "Sold out".
// This is only the submit.
//
// Klaviyo's own widget was the original plan and was dropped for two reasons: their sign-up
// forms cannot use their Smart translation feature, so the copy would have stayed English on
// every market, and their documentation says installation "is only supported for certain free
// Shopify themes, and not for Shopify stores using custom themes".
//
// POST https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=<public site ID>
// The /client endpoints authenticate with the public site ID alone - the same key already in
// the page for onsite tracking - so nothing secret is involved and this can run in the browser.
//
// Everything is delegated off the document rather than bound per form: the theme re-renders
// the whole product-info block when the visitor switches variant, which replaces these nodes.
// For the same reason the variant id is read at submit time, off the data attribute, instead
// of being captured once.
(function () {
  var config = (window.themeVariables && window.themeVariables.backInStock) || null;
  var strings = (window.themeVariables && window.themeVariables.strings) || {};

  if (!config || !config.companyId) return;

  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';
  var SUBSCRIBE_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';

  // Shopify variant ids reach Klaviyo's catalog under a composite key:
  // integration:::catalog:::external id.
  function catalogVariantId(variantId) {
    return '$shopify:::$default:::' + variantId;
  }

  // E.164 without a regex, so nothing here depends on escape sequences surviving: a leading
  // plus, then 8 to 15 digits and nothing else. Deliberately permissive - Klaviyo does the
  // real validation, this only catches the obvious typo before spending a request on it.
  function looksLikePhone(value) {
    if (value.charAt(0) !== '+') return false;

    var digits = 0;

    for (var i = 1; i < value.length; i++) {
      var c = value.charAt(i);
      if (c === ' ' || c === '-' || c === '(' || c === ')') continue;
      if (c < '0' || c > '9') return false;
      digits++;
    }

    return digits >= 8 && digits <= 15;
  }

  function showError(form, message) {
    var el = form.querySelector('.back-in-stock__error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(form) {
    var el = form.querySelector('.back-in-stock__error');
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  // The marketing opt-in, sent to Klaviyo's own subscribe endpoint.
  //
  // The first attempt at this went through Shopify's /contact instead, so that no Klaviyo
  // list would be needed - Kai had asked whether the status could change without one. It
  // cannot, from a browser. Klaviyo requires a list on the endpoint a public key can reach,
  // and the endpoint that does not require one needs a private key and a server. Shopify
  // looked like the way round it, and the consent does reach Klaviyo through the
  // integration, but the store has spam protection on customer forms: a hand-built POST to
  // /contact is answered with 400 "Missing CAPTCHA token", because the token is injected
  // only into Shopify's own rendered forms. A dedicated list is the honest answer.
  //
  // The list is only the entry point. Consent is set on the profile, under
  // subscriptions.email.marketing, so these people count as subscribers account-wide and
  // not merely as members of one list.
  //
  // Fire and forget, deliberately. The visitor came for the stock alert; if the marketing
  // sign-up fails there is nothing they could do about it and nothing to fix from this form,
  // so it must not be able to turn a successful subscription into an error message.
  function subscribeToEmailList(email, listId) {
    if (!listId) return;

    fetch(SUBSCRIBE_ENDPOINT + '?company_id=' + encodeURIComponent(config.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: config.revision,
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'back-in-stock-form',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } },
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        },
      }),
    }).catch(function () {});
  }

  // The phone field only exists when the SMS setting is on, and only matters once the
  // visitor asks for it.
  document.addEventListener('change', function (event) {
    var checkbox = event.target;
    if (!checkbox.name || checkbox.name !== 'sms_opt_in') return;

    var form = checkbox.closest('.back-in-stock__form');
    if (!form) return;

    var block = form.querySelector('.back-in-stock__sms');
    if (!block) return;

    block.hidden = !checkbox.checked;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('back-in-stock__form')) return;

    event.preventDefault();

    var root = form.closest('back-in-stock');
    if (!root) return;

    var variantId = root.getAttribute('data-variant-id');
    if (!variantId) return;

    var emailInput = form.querySelector('input[type="email"]');
    var smsCheckbox = form.querySelector('input[name="sms_opt_in"]');
    var phoneInput = form.querySelector('input[type="tel"]');
    var submitButton = form.querySelector('button[type="submit"]');

    if (!emailInput || !emailInput.validity.valid || !emailInput.value.trim()) {
      showError(form, strings.backInStockErrorEmail);
      emailInput && emailInput.focus();
      return;
    }

    var channels = ['EMAIL'];
    var profile = { email: emailInput.value.trim() };

    if (smsCheckbox && smsCheckbox.checked) {
      var phone = phoneInput ? phoneInput.value.trim() : '';

      if (!looksLikePhone(phone)) {
        showError(form, strings.backInStockErrorPhone);
        phoneInput && phoneInput.focus();
        return;
      }

      channels.push('SMS');
      profile.phone_number = phone;
    }

    clearError(form);

    // Sent alongside the stock subscription rather than after it: they are independent, and
    // this one is not allowed to affect what the visitor sees either way.
    var listCheckbox = form.querySelector('input[name="email_list_opt_in"]');

    if (listCheckbox && listCheckbox.checked) {
      subscribeToEmailList(profile.email, root.getAttribute('data-list-id'));
    }

    // A second click while the first request is in flight would create a duplicate
    // subscription, which Klaviyo rejects - so the visitor would see an error for having
    // been too quick.
    if (submitButton) submitButton.disabled = true;

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(config.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: config.revision,
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: channels,
            profile: {
              data: {
                type: 'profile',
                attributes: profile,
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: catalogVariantId(variantId),
              },
            },
          },
        },
      }),
    })
      .then(function (response) {
        // 202 with no body is the documented success. 409 is not documented for this
        // endpoint, but a repeat of the same profile and variant is rejected rather than
        // accepted, so it is worth telling the visitor they are already on the list instead
        // of showing them a generic failure.
        if (response.status === 202) {
          var success = root.querySelector('.back-in-stock__success');
          form.hidden = true;

          if (success) {
            success.hidden = false;
            var heading = success.querySelector('.h5');
            if (heading) {
              heading.setAttribute('tabindex', '-1');
              heading.focus();
            }
          }

          return;
        }

        if (submitButton) submitButton.disabled = false;

        if (response.status === 409) {
          showError(form, strings.backInStockErrorDuplicate);
          return;
        }

        showError(form, strings.backInStockErrorGeneric);
      })
      .catch(function () {
        // Offline, blocked by an extension, or Klaviyo unreachable. No detail to give that
        // the visitor could act on, and nothing is logged: the payload carries their email.
        if (submitButton) submitButton.disabled = false;
        showError(form, strings.backInStockErrorGeneric);
      });
  });
})();

/*
 * Predictive search in languages Shopify does not support. (KAN-168)
 *
 * The header search asks /{locale}/search/suggest for results whenever the
 * shopify-features script says predictiveSearch is true, and Shopify says
 * true on /zh too. But the Predictive Search API only serves the buyer locales
 * listed at shopify.dev/docs/api/ajax/reference/predictive-search, and Chinese
 * is not one of them: /zh/search/suggest answers 417 "Unsupported buyer
 * locale", the theme finds no section in the response, and the dropdown stays
 * empty.
 *
 * The theme already has a fallback for this case: when the flag is false it
 * renders the same predictive-search section through ordinary search
 * (/search?section_id=predictive-search), which works in every language. This
 * only corrects the flag for languages outside Shopify's list. theme.js is a
 * compiled upstream bundle, so the method is patched on the element's
 * prototype rather than edited there.
 */
(function () {
  var SUPPORTED = [
    'af', 'sq', 'hy', 'bs', 'bg', 'ca', 'hr', 'cs', 'da', 'nl', 'en', 'et', 'fo', 'fi', 'fr', 'gd',
    'de', 'el', 'hu', 'is', 'id', 'it', 'la', 'lv', 'lt', 'mk', 'mo', 'no', 'nb', 'nn', 'pl', 'pt',
    'ro', 'ru', 'sr', 'sh', 'sk', 'sl', 'es', 'sv', 'tr', 'uk', 'vi', 'cy',
  ];
  var locale = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').toLowerCase();
  if (SUPPORTED.indexOf(locale.split('-')[0]) !== -1) return;
  if (!window.customElements) return;

  window.customElements.whenDefined('predictive-search').then(function () {
    var PredictiveSearch = window.customElements.get('predictive-search');
    if (!PredictiveSearch || typeof PredictiveSearch.prototype.supportsPredictiveApi !== 'function') return;
    PredictiveSearch.prototype.supportsPredictiveApi = function () {
      return false;
    };
  });
})();

// === Judge.me widgets: theme adjustments that need the rendered markup ===
// Judge.me renders with Vue after load and re-renders on sort / paging, so everything
// here is idempotent and re-applied on DOM changes (batched to one pass per frame).
//  1. Stars: same sharp star as the theme cards. Each star gets --ab-star-fill from the
//     rating's aria-label ("4.78 out of 5 stars") and its own colour; CSS draws it.
//  2. AI summary highlights: only quotes that are cut off open a popup, so the rest
//     get .ab-jm-hl-static (no chevron, not clickable).
//  3. Product page sort menu: Safari ignores display:none on <option>, so the options we
//     hide in CSS also get hidden + disabled here.
//  4. Reviews linked to a product that's gone (draft / archived / deleted): checked once
//     per product via /products/<handle>.js; the link is disabled and labelled.
(function () {
  var HIDDEN_SORTS = ['videos_first', 'most_helpful', 'with_pictures', 'pictures_first'];
  var productStatus = {}; // handle -> 'ok' | 'gone' | Promise

  function score(rating) {
    var label = rating.getAttribute('aria-label') || '';
    var m = label.match(/([0-9]+(?:[.,][0-9]+)?)/);
    var s = m ? parseFloat(m[1].replace(',', '.')) : parseFloat(rating.getAttribute('data-score'));
    return isNaN(s) ? null : s;
  }

  function stars(root) {
    root.querySelectorAll('.jm-star-rating').forEach(function (rating) {
      var s = score(rating);
      if (s === null) return;
      var icons = rating.querySelectorAll('.jm-star-rating__font-icon');
      icons.forEach(function (icon, i) {
        var fill = Math.max(0, Math.min(1, s - i)) * 100 + '%';
        if (!icon.classList.contains('ab-jm-star')) {
          // Keep Judge.me's star colour (set inline / via their variables) before hiding the glyph
          icon.style.setProperty('--ab-star-color', getComputedStyle(icon).color);
          icon.classList.add('ab-jm-star');
        }
        if (icon.style.getPropertyValue('--ab-star-fill') !== fill) icon.style.setProperty('--ab-star-fill', fill);
      });
    });
  }

  function highlights(root) {
    root.querySelectorAll('.jm-review-highlights__row').forEach(function (row) {
      var text = row.querySelector('.jm-review-highlights__text') || row;
      var cut = text.scrollWidth > text.clientWidth + 1 || text.scrollHeight > text.clientHeight + 1;
      row.classList.toggle('ab-jm-hl-static', !cut);
    });
  }

  function sorts(root) {
    root.querySelectorAll('.jdgm-review-widget .jm-sort-filter__select option').forEach(function (opt) {
      if (HIDDEN_SORTS.indexOf(opt.value) !== -1 && !opt.hidden) {
        opt.hidden = true;
        opt.disabled = true;
      }
    });
  }

  function handleOf(href) {
    try {
      var m = new URL(href, location.origin).pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function markGone(link) {
    if (link.classList.contains('ab-jm-gone')) return;
    link.classList.add('ab-jm-gone');
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    var label = document.createElement('span');
    label.className = 'ab-jm-gone-label';
    label.textContent = (window.abStrings && window.abStrings.productUnavailable) || 'No longer available';
    link.insertAdjacentElement('afterend', label);
  }

  // One HEAD request per product (no body downloaded), remembered for the browsing session.
  // Anything other than a clear 404 counts as available, so a link is never wrongly disabled.
  var CACHE_KEY = 'abJmProductStatus';
  try {
    productStatus = JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {};
  } catch (e) {
    productStatus = {};
  }
  function remember(handle, status) {
    productStatus[handle] = status;
    try {
      var plain = {};
      Object.keys(productStatus).forEach(function (k) {
        if (typeof productStatus[k] === 'string') plain[k] = productStatus[k];
      });
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(plain));
    } catch (e) {}
    return status;
  }
  function check(handle) {
    if (!productStatus[handle]) {
      productStatus[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { method: 'HEAD', credentials: 'same-origin' })
        .then(function (r) {
          return remember(handle, r.status === 404 ? 'gone' : 'ok');
        })
        .catch(function () {
          return remember(handle, 'ok');
        });
    }
    return Promise.resolve(productStatus[handle]);
  }

  function productLinks(root) {
    var links = root.querySelectorAll(
      '.jm-review-widget a[href*="/products/"], .jdgm-review-snippet-widget-v2 a[href*="/products/"], .jdgm-modal a[href*="/products/"]'
    );
    links.forEach(function (link) {
      if (link.dataset.abJmChecked) return;
      link.dataset.abJmChecked = '1';
      var handle = handleOf(link.getAttribute('href'));
      if (!handle) return;
      check(handle).then(function (status) {
        if (status === 'gone') markGone(link);
      });
    });
  }

  // 5. Popup close button: on desktop Judge.me places the X outside the panel. Pin it
  //    to the panel's top-right corner, whatever their markup nesting is.
  function closeButton() {
    document.querySelectorAll('.jdgm-modal').forEach(function (modal) {
      var panel = modal.querySelector('.jm-slide, .jdgm-rev-snippet-lightbox');
      var btn = modal.querySelector('button[aria-label*="lose" i], button[class*="close" i], [class*="close" i][role="button"]');
      if (!panel || !btn) return;
      if (window.innerWidth < 700) {
        btn.classList.remove('ab-jm-close');
        btn.style.removeProperty('top');
        btn.style.removeProperty('left');
        return;
      }
      var p = panel.getBoundingClientRect();
      if (!p.width) return;
      var size = btn.offsetWidth || 40;
      // Measure again once the opening animation has finished.
      if (!btn.classList.contains('ab-jm-close')) setTimeout(schedule, 400);
      btn.classList.add('ab-jm-close');
      btn.style.top = Math.round(p.top + 12) + 'px';
      btn.style.left = Math.round(p.right - size - 12) + 'px';
    });
  }

  var scheduled = false;
  function run() {
    scheduled = false;
    if (!document.querySelector('.jm-review-widget, .jdgm-review-snippet-widget-v2, .jdgm-modal')) return;
    stars(document);
    highlights(document);
    sorts(document);
    productLinks(document);
    closeButton();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  var JM = '.jm-review-widget, .jdgm-widget, .jdgm-modal';
  function touchesJudgeMe(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      var el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      if (el && el.closest(JM)) return true;
      for (var j = 0; j < r.addedNodes.length; j++) {
        var n = r.addedNodes[j];
        if (n.nodeType === 1 && (n.matches(JM) || n.querySelector(JM))) return true;
      }
    }
    return false;
  }

  function start() {
    run();
    // The whole page is watched because Judge.me mounts late, but only changes inside its
    // widgets trigger a pass - other carousels and apps don't cost anything here.
    new MutationObserver(function (records) {
      if (touchesJudgeMe(records)) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// === Judge.me review snippet: pagination dots ===
// Judge.me's snippet carousel has no dots. Adds one per review, synced to the
// track's scroll position; clicking a dot scrolls to that review.
(function () {
  function setup(widget) {
    var track = widget.querySelector('.jm-carousel__track');
    var carousel = widget.querySelector('.jm-carousel');
    if (!track || !carousel) return;

    var cards = track.querySelectorAll('.jdgm-rev-snippet-card');
    var existing = widget.querySelector('.ab-snippet-dots');
    if (existing && existing.children.length === cards.length) return;
    if (existing) existing.remove();
    if (cards.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'ab-snippet-dots';

    function step() {
      return cards[1].offsetLeft - cards[0].offsetLeft || track.clientWidth;
    }

    function update() {
      var i = Math.round(track.scrollLeft / step());
      Array.prototype.forEach.call(dots.children, function (dot, n) {
        dot.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(cards, function (card, n) {
      var dot = document.createElement('button');
      dot.type = 'button';
      var strings = (window.themeVariables && window.themeVariables.strings) || {};
      var label = (strings.reviewSlide || '{{ index }} / {{ count }}')
        .replace('{{ index }}', n + 1)
        .replace('{{ count }}', cards.length);
      dot.setAttribute('aria-label', label);
      dot.addEventListener('click', function () {
        track.scrollTo({ left: n * step(), behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });

    carousel.insertAdjacentElement('afterend', dots);
    if (!track.dataset.abDots) {
      track.dataset.abDots = '1';
      track.addEventListener('scroll', function () {
        requestAnimationFrame(update);
      }, { passive: true });
    }
    update();
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll('.jdgm-review-snippet-widget-v2').forEach(setup);
  }

  function start() {
    scan();
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(scan, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
// === Product card wishlist: next-to-title placement and saved state (Theme settings > Product card) ===
// Wishlist Power injects its button into .product-card__figure (top right of the image). Cards rendered
// with the "next to title" position carry .product-card--wishlist-info; move the button into the
// card's info strip, where custom.css places it beside the title.
(function () {
  var queued = false;
  // Desktop shows the icon on hover only (custom.css); a saved product keeps it visible. The saved
  // state lives on the app's button inside its shadow root, so mirror it onto the wrapper as .is-saved.
  var watched = new WeakSet();
  function syncSaved(wrap) {
    var host = wrap.querySelector('ooo-wl-product-card-button');
    var button = host && host.shadowRoot && host.shadowRoot.querySelector('button[role="checkbox"]');
    if (!button) return;
    var update = function () { wrap.classList.toggle('is-saved', button.getAttribute('aria-checked') === 'true'); };
    update();
    if (watched.has(button)) return;
    watched.add(button);
    new MutationObserver(update).observe(button, { attributes: true, attributeFilter: ['aria-checked'] });
  }
  function place() {
    queued = false;
    document.querySelectorAll('.product-card--wishlist-info > .product-card__figure > ooo-wl-access-button').forEach(function (wrap) {
      var info = wrap.closest('.product-card').querySelector('.product-card__info');
      if (info) info.appendChild(wrap);
    });
    document.querySelectorAll('.product-card ooo-wl-access-button').forEach(syncSaved);
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(place);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  // The app fills its shadow roots after load, which the observer above can't see; catch up a few times.
  [1500, 4000, 8000].forEach(function (delay) { setTimeout(queue, delay); });
})();

// === Navigation helpers (replace the old ab-clear-menu.js) ===
// 1. Unpublished preview themes: Shopify drops ?preview_theme_id on some navigations, which silently
//    lands a reviewer on the live theme. Keep it on same-store links while browsing a preview.
// 2. Mobile menu search bar (snippets/header-sidebar.liquid, data-sidebar-search): close the sidebar,
//    then open the header search drawer (the Searchanise-powered one).
(function () {
  var theme = window.Shopify && window.Shopify.theme;
  var previewId = theme && theme.role === 'unpublished' ? String(theme.id) : null;

  if (previewId) {
    var current = new URL(location.href);
    if (current.searchParams.get('preview_theme_id') !== previewId) {
      current.searchParams.set('preview_theme_id', previewId);
      history.replaceState(history.state, '', current.href);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');

      if (previewId && link && link.getAttribute('href').charAt(0) !== '#') {
        try {
          var url = new URL(link.href);
          if (url.origin === location.origin && /^\/(?:$|collections|products|pages|search|cart)/.test(url.pathname)) {
            url.searchParams.set('preview_theme_id', previewId);
            link.href = url.href;
          }
        } catch (e) {}
      }

      var search = event.target.closest && event.target.closest('[data-sidebar-search]');
      if (search) {
        var sidebar = search.closest('header-sidebar');
        var drawer = document.getElementById(search.getAttribute('aria-controls'));
        if (sidebar && sidebar.hide && drawer && drawer.show) {
          event.preventDefault();
          event.stopImmediatePropagation();
          Promise.resolve(sidebar.hide()).then(function () {
            drawer.show();
          });
        }
      }
    },
    true
  );
})();

// === #filter-<name> links (snippets/facets.liquid marks each filter with data-facet-group) ===
// A URL ending in #filter-stone opens the Stone filter - the filter drawer first on mobile - and
// focuses its search box (added by assets/collection-filter-search.js when the filter is long).
(function () {
  function isShown(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function openFilterFromHash() {
    var m = location.hash.match(/^#filter-([a-z0-9_-]+)$/i);
    if (!m) return;
    var name = m[1].toLowerCase();
    var anchors = Array.prototype.filter.call(document.querySelectorAll('[data-facet-group]'), function (a) {
      var param = a.getAttribute('data-facet-group').toLowerCase();
      return param === name || param.slice(-(name.length + 1)) === '.' + name;
    });
    if (!anchors.length) return;

    // Desktop: the copy in the visible sidebar. Mobile: the copy inside the (closed) filter drawer.
    var desktop = window.matchMedia('(min-width: 1000px)').matches;
    var anchor = anchors.filter(function (a) {
      var details = a.closest('details');
      var host = details ? details.parentElement : a;
      return desktop ? isShown(host) : !!a.closest('facets-drawer');
    })[0] || anchors[0];

    var details = anchor.closest('details');
    var drawer = anchor.closest('facets-drawer');

    function reveal() {
      // Grid-first layout tucks some filters behind "More filters" - expand that too.
      var more = anchor.closest('[data-abgf-collapsed]');
      if (more) {
        more.removeAttribute('data-abgf-collapsed');
        var toggle = document.querySelector('[aria-controls="' + more.id + '"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
      if (details && !details.open) details.open = true;
      var input = details && details.querySelector('[data-filter-value-search]');
      var target = details || anchor.parentElement;
      // Brief gold pulse so a repeat click on the same page visibly does something.
      var flash = (input && input.closest('.filter-value-search')) || (details && details.querySelector('summary'));
      if (flash) {
        flash.classList.remove('ab-flash');
        void flash.offsetWidth;
        flash.classList.add('ab-flash');
        setTimeout(function () { flash.classList.remove('ab-flash'); }, 1800);
      }
      if (!drawer) {
        var sticky = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
        skbSmoothScroll(Math.max(0, window.pageYOffset + target.getBoundingClientRect().top - sticky - 16), 500);
      }
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, drawer ? 350 : 520);
    }

    if (drawer && !desktop && drawer.show) {
      Promise.resolve(drawer.show()).then(reveal);
    } else {
      reveal();
    }
  }

  window.addEventListener('hashchange', openFilterFromHash);

  // Same page, same hash (e.g. "Browse all stones" clicked again while already on the collection):
  // the browser fires no hashchange, so handle the click directly.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="#filter-"]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    var url = new URL(link.href, location.href);
    if (url.pathname !== location.pathname || !/^#filter-/i.test(url.hash)) return;
    if (!document.querySelector('[data-facet-group]')) return;
    event.preventDefault();
    if (location.hash !== url.hash) history.replaceState(history.state, '', url.hash);
    // Let an open header dropdown / mobile menu close first.
    var sidebar = document.getElementById('sidebar-menu');
    if (sidebar && sidebar.hide && sidebar.hasAttribute('open')) {
      Promise.resolve(sidebar.hide()).then(openFilterFromHash);
    } else {
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      document.querySelectorAll('.header__menu-disclosure[open]').forEach(function (d) { d.open = false; });
      openFilterFromHash();
    }
  });
  if (document.readyState === 'complete') openFilterFromHash();
  else window.addEventListener('load', openFilterFromHash);
})();
